import { Injectable } from '@angular/core';
import { DirectoryService as CommonDirectoryService } from '@iot-platform/data-access';
import { Timezone } from '@iot-platform/models/xmqtt';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DirectoryService extends CommonDirectoryService {
  override getTimezones(): Observable<Timezone[]> {
    return this.http.get<Timezone[]>(`${this.environment.api.url_connector}${this.environment.api.endpoints.timezones}`).pipe(
      map((result: Timezone[]) =>
        result.map((item: Timezone) => ({
          ...item,
          key: `${item.windows} ${item.iana}`,
          value: item.windows
        }))
      ),
      catchError(() => of([]))
    );
  }
}
